import { render } from "./Announcement.vue?vue&type=template&id=234bd71c"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
script.render = render

export default script